<template>
  <div class="main">
    <component :is="item" />
  </div>
</template>

<script>
// 公司介绍
import pageCompany from './company'
// 联系我们
import pageContact from './contact'
// 实体站展示
import pageEntity from './entity'
// 组织机构
import pageStructure from './structure'
// 分公司办事处
import pageFiliale from './filiale'

export default {
  props: {
    item: {
      type: String,
      required: true,
      default: "pageCompany"
    }
  },
  data() {
    return {
    }
  },
  components: {
    pageCompany,
    pageContact,
    pageEntity,
    pageFiliale,
    pageStructure
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>